<template>
    <div
        :class="{
            'updateImg-margin': !noMargin,
        }"
        class="updateImg"
        :style="{
            width: width + 'px',
            height: height + 'px',
        }"
    >
        <Upload
            ref="upload"
            :accept="accept"
            name="file"
            type="drag"
            :data="{field}"
            :multiple="multiple"
            :format="['jpeg', 'jpg', 'bmp', 'png', 'JPEG', 'JPG', 'BMP', 'PNG']"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :max-size="maxSize"
            :on-format-error="uploadFormatError"
            :on-exceeded-size="uploadSize"
            :action="url"
            :before-upload="beforeUpload"
        >
            <div
                v-if="!imgSrc && item" v-click="{serverId: 20062, area: 'upload-click'}"
                class="imgbox"
            >
                <veui-icon class="imgbox-add" name="plus"/>
                上传形象照
            </div>
            <div
                v-if="imgSrc && item" v-click="{serverId: 20062, area: 'upload-click'}"
                class="imgbox"
            >
                <div
                    class="imglist"
                    :style="{
                        width: width - 2 + 'px',
                        height: height - 2 + 'px',
                    }"
                >
                    <img :src="imgSrc"/>
                </div>
                <div class="reload">
                    <div class="reload-box">
                        <div @click.stop="previewImgSrc"><veui-icon class="reload-box-icon" name="eye"/></div>
                        <div><veui-icon class="reload-box-icon" name="upload"/></div>
                        <div @click.stop="clearImgSrc"><veui-icon class="reload-box-icon" name="trash"/></div>
                    </div>
                </div>
            </div>
        </Upload>
        <veui-dialog
            class="dialog"
            overlay-class="cropper-avator-dialog-new"
            ui="auto"
            :title="cropModalTitle"
            :open.sync="cropper.show"
            :before-close="crop"
        >
            <div class="cropper-tip">
                <div class="cropper-tip-icon"></div>
                为满足头像展示要求，请参照框线放置面部，以达到最佳呈现效果
            </div>
            <!-- 截图组件 -->
            <div class="cropper">
                <vue-cropper
                    ref="cropper"
                    :img="cropper.img"
                    :can-scale="cropper.canScale"
                    :output-size="cropper.outputSize"
                    :output-type="cropper.outputType"
                    :info="cropper.info"
                    :full="cropper.full"
                    :can-move="cropper.canMove"
                    :can-move-box="cropper.canMoveBox"
                    :original="cropper.original"
                    :auto-crop="cropper.autoCrop"
                    :auto-crop-width="cropper.autoCropWidth"
                    :auto-crop-height="cropper.autoCropHeight"
                    :center-box="cropper.centerBox"
                    :info-true="cropper.infoTrue"
                    :fixed="cropper.fixed"
                    :fixed-box="cropper.fixedBox"
                    :fixed-number="cropper.fixedNumber"
                    :mode="cropper.mode"
                    :enlarge="cropper.enlarge"
                    :limit-min-size="cropper.limitMinSize"
                ></vue-cropper>
                <div class="avatar-border-bg"></div>
                <div class="scale-box">
                    <div class="zoom-in" @click="zoomIn">
                    </div>
                    <div class="zoom-out" @click="zoomOut">
                    </div>
                </div>
            </div>
            <template #foot="{close}">
                <veui-button
                    class="last-step-btn strong"
                    @click="close('last-step')"
                >
                    上一步
                </veui-button>
                <veui-button
                    class="confirm-btn primary"
                    @click="close('ok')"
                >
                    下一步
                </veui-button>
            </template>
        </veui-dialog>
        <veui-dialog
            :open.sync="previewDialogOpen"
            overlay-class="uploader-preview-dialog"
            footless
            outside-closable
            ui="auto"
        >
            <img :src="imgSrc" style="min-width: 240px; max-width: 480px;">
        </veui-dialog>
        <avatar-choose-dialog
            v-if="avatarChooseDialogShow"
            ref="avatarChooseDialog"
            :avatar="originUrl"
            :origin-avatar="imgSrc"
            @handleNext="handleNext"
            @close="closeAvatarChooseModal"
        />
    </div>
</template>

<script>
/**
 * @desc 上传组件
 * @author YongZhang<zhangyong06@baidu.com>
 * @file UploadImg.vue
*/
// import AddBox from './AddBox';
import {VueCropper} from 'vue-cropper';
import {Icon, Dialog, Button} from 'veui';
import 'veui-theme-dls-icons';
import avatarChooseDialog from './avatar-choose-dialog.vue';
/**
 * 默认裁剪配置
 */
export const cropperOptions = {
    img: '', // 裁剪图片的地址
    outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
    outputType: 'png', // 裁剪生成图片的格式（jpeg || png || webp）
    info: true, // 图片大小信息
    canScale: true, // 图片是否允许滚轮缩放
    autoCrop: true, // 是否默认生成截图框
    autoCropWidth: 468, // 默认生成截图框宽度
    autoCropHeight: 468, // 默认生成截图框高度
    fixed: true, // 是否开启截图框宽高固定比例
    fixedNumber: [1, 1], // 截图框的宽高比例
    full: false, // false按原比例裁切图片，不失真
    fixedBox: true, // 固定截图框大小，不允许改变
    canMove: true, // 上传图片是否可以移动
    canMoveBox: false, // 截图框能否拖动
    original: false, // 上传图片按照原始比例渲染
    centerBox: false, // 截图框是否被限制在图片里面
    height: false, // 是否按照设备的dpr 输出等比例图片
    infoTrue: true, // true为展示真实输出图片宽高，false展示看到的截图框宽高
    enlarge: 2, // 图片根据截图框输出比例倍数
    originAvatar: '', // 最终的原头像
    curOriginAvatar: '' // 暂存的原头像，可以没提交
};

export default {
    name: 'UpdateImg',
    // 上传文案，上传主体如头像、身份证照片等、上传文件大小限制、图片是否非必须
    props: {
        width: {
            'type': [Number, String],
            'default': 120
        },
        height: {
            'type': [Number, String],
            'default': 120
        },
        text: {
            'type': String,
            'default': ''
        },
        item: {
            'type': String,
            'default': ''
        },
        maxSize: {
            'type': Number,
            'default': 10240000
        },
        accept: {
            'type': String,
            'default': 'image/jpeg,image/jpg,image/bmp,image/png'
        },
        imgSrc: {
            'type': String,
            'default': ''
        },
        type: {
            'type': String,
            'default': ''
        },
        defaultImg: {
            'type': String,
            'default': ''
        },
        isNotEssential: {
            'type': Boolean,
            'default': false
        },
        isFromUC: {
            'type': Boolean,
            'default': false
        },
        field: {
            'type': String,
            'default': ''
        },
        idx: {
            'type': Number,
            'default': undefined
        },
        noMargin: {
            'type': Boolean,
            'default': false
        },
        multiple: {
            'type': Boolean,
            'default': false
        },
        cropperOptions: {
            'type': Object,
            'default': () => ({
                ...cropperOptions
            })
        },
        uploadBtnTitle: {
            'type': String,
            'default': '重新上传'
        },
        cropModalTitle: {
            'type': String,
            'default': '编辑图片'
        },
        url: {
            'type': String,
            'default': '/bp/api/upload?ajax=1&bdstoken='
        }
    },
    data() {
        return {
            fileData: '',
            cropper: {
                show: false,
                loading: false,
                ...Object.assign({}, cropperOptions, this.cropperOptions)
            },
            previewDialogOpen: false,
            originUrl: this.imgSrc,
            avatarChooseDialogShow: false,
            isAvatarChange: false,
            isSelectAi: false,
            isSubmitAi: false
        };
    },
    components: {
        'vue-cropper': VueCropper,
        'veui-icon': Icon,
        'veui-dialog': Dialog,
        'avatar-choose-dialog': avatarChooseDialog,
        'veui-button': Button
    },
    methods: {
        beforeUpload(file) {
            if (this.isFromUC) {
                this.$Message.error('UC用户不可更改');
                return false;
            }
        },
        uploadSuccess(res) {
            if (+res.code === 0 && res.data && res.data?.bos_url) {
                this.originUrl = res.data?.bos_url;
                this.isUploadSuccess = 1;
                this.openAvatarChooseModal(1);
            }
            else {
                this.$Message.error({
                    content: res.msg || '上传失败、请检查网络或重试',
                    duration: 5
                });
            }
        },
        uploadError() {
            this.$Message.error({
                content: '上传失败、请检查网络或重试',
                duration: 5
            });
        },
        uploadFormatError() {
            this.$Message.error({
                content: '文件格式错误,支持jpeg、jpg、bmp、png文件',
                duration: 5
            });
        },
        uploadSize() {
            this.$Message.error({
                content: '文件过大，上传失败',
                duration: 5
            });
        },
        clearImgSrc() {
            this.$emit('upload-suc', '', this.idx);
        },
        previewImgSrc() {
            this.previewDialogOpen = true;
        },
        // 截图弹窗'确认'事件
        crop(type) {
            // 裁剪完成后的处理逻辑
            if (type === 'ok') {
                this.isSubmitAi = this.isSelectAi;
                this.originAvatar = this.curOriginAvatar;
                this.isUploadSuccess === 0;
                // 计算裁剪区域实际宽高
                const w = this.$refs.cropper.cropW * this.cropper.enlarge;
                const h = this.$refs.cropper.cropH * this.cropper.enlarge;
                // 验证裁剪区域是否为1:1正方形且尺寸有效
                if (!(w === h && w >= 0 && h >= 0)) {
                    this.$Message.error({
                        content: '上传图片宽高要求1:1',
                        duration: 3
                    });
                    return false;
                }
                this.$wywLog.send({
                    serverId: 20062,
                    area: 'cropper-dialog-next-step',
                    action: 'click'
                });
                // 获取裁剪后的blob数据并上传
                this.$refs.cropper.getCropBlob(async blob => {
                    const file = new File([blob], 'avatar.png', {type: 'image/png'});
                    let url = await this.uploadImage(file);
                    this.$emit('upload-suc', url);
                });
            }
            else if (type === 'last-step') {
                this.$wywLog.send({
                    serverId: 20062,
                    area: 'cropper-dialog-last-step',
                    action: 'click'
                });
                // 显示头像选择对话框
                this.$refs.avatarChooseDialog.show(false, 'last-step');
            }
            // x关闭事件
            else if (type === 'cancel') {
                this.$wywLog.send({
                    serverId: 20062,
                    area: 'cropper-dialog-x',
                    action: 'click'
                });
                this.isUploadSuccess = 2;
            }
        },
        // 手动放大
        zoomIn() {
            this.$refs.cropper.scale = this.$refs.cropper.scale + 0.05;
        },
        // 手动缩小
        zoomOut() {
            this.$refs.cropper.scale = this.$refs.cropper.scale - 0.05;
        },

        /**
         * 选择头像后下一步事件
         * @param {string} url 头像图片地址
         * @param {boolean} isAvatarChange 是否头像更换
         * @param {boolean} isSelectAi 是否选择的ai头像
         * @param {string} originAvatar 原始头像地址
         */

        handleNext({url, isSelectAi, originAvatar = ''}) {
            let timeStr = new Date().getTime();
            this.cropper.img = url + '?' + timeStr;
            this.cropper.show = true;
            this.$wywLog.send({
                serverId: 20062,
                area: 'cropper-dialog',
                action: 'show'
            });
            this.isSelectAi = isSelectAi || false;
            this.curOriginAvatar = originAvatar;
        },
        openAvatarChooseModal(isUpload) {
            this.$wywLog.send({
                serverId: 20062,
                area: 'avatar-choose-dialog',
                action: 'show'
            });
            if (isUpload || this.isSubmitAi) {
                if (this.isSubmitAi) {
                    this.originUrl = this.imgSrc;
                    this.isSubmitAi = false;
                }
                this.avatarChooseDialogShow = false;
                this.$nextTick(() => {
                    this.avatarChooseDialogShow = true;
                });
                return;
            }
            if (this.avatarChooseDialogShow) {
                // 2表示本组件重新上传了头像，但最后在裁剪环节点了x关闭
                if (this.isUploadSuccess === 2) {
                    this.originUrl = this.imgSrc;
                    this.isUploadSuccess = 0;
                }
                this.$refs.avatarChooseDialog.show();
            }
            else {
                this.avatarChooseDialogShow = true;
            }
        },
        closeAvatarChooseModal() {
            this.avatarChooseDialogShow = false;
            // 重置图片地址
            this.originUrl = this.imgSrc;
        },
        uploadImage(file) {
            const formData = new FormData();
            formData.append('file', file);
            return new Promise((resolve, reject) => {
                this.$http.post(this.url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (res && +res.code === 0) {
                        let url = res.data?.bos_url;
                        resolve(url);
                    }
                    else {
                        reject();
                        this.$toast.error(res && res.msg || '上传失败，请稍后再试～');
                    }
                })
                    .catch(() => {
                        reject();
                        this.$toast.error('上传失败，请稍后再试～');
                    });
            });
        }
    }
};

</script>
<style scoped lang="less">
.updateImg {
    position: relative;
    size: 120px;

    ::v-deep .ivu-upload {
        height: 100%;
    }

    ::v-deep .ivu-upload-drag {
        display: flex;
        width: 120px;
        height: 120px;
        position: relative;
        box-sizing: border-box;
        border: 1px solid #eee;

        &::after {
            border-style: solid;
        }
    }

    .imgbox {
        height: 100%;
        width: 100%;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        line-height: 1;
        color: #848691;

        .imgbox-add {
            height: 16px;
            color: #848691;
            margin-bottom: 10px;
        }

        .imglist {
            display: table-cell;
            vertical-align: middle;
            position: relative;
            height: 120px;
            width: 120px;

            img {
                max-height: 100%;
                max-width: 100%;
            }
        }

        .reload {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            line-height: 120px;
            font-size: 14px;
            color: #fff;
            display: none;

            .reload-box {
                position: absolute;
                width: 100%;
                padding: 4px 12px;
                height: 26px;
                left: 0;
                bottom: 0;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                background: rgba(0, 0, 0, .6);

                div {
                    height: 26px;
                    line-height: 26px;
                    font-size: 12px;
                    margin-left: 12px;
                }
            }
        }

        &:hover .reload {
            display: block;
        }
    }
}

.cropper-tip {
    border: 1px solid #e0ebff;
    backdrop-filter: blur(27.18px);
    border-radius: 6px;
    height: 34px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 1;
    display: flex;
    align-items: center;
    padding: 0 12px;
    background: #0055ff0d;
    margin: 15px 0  18px;

    .cropper-tip-icon {
        height: 16px;
        width: 16px;
        margin-right: 8px;
        background: url("https://lvlin-fe-saas.bj.bcebos.com/material/!.png") no-repeat center center / 100% 100%;
    }
}

.cropper {
    height: 468px;
    width: 468px;
    margin: 0 auto;
    position: relative;
}

.scale-box {
    margin-top: 20px;
    text-align: center;
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 16px;

    .zoom-in {
        height: 30px;
        width: 30px;
        cursor: pointer;
        background: url("https://lvlin-fe-saas.bj.bcebos.com/material/fangda.png") no-repeat center / 100% 100%;
    }

    .zoom-out {
        height: 30px;
        width: 30px;
        cursor: pointer;
        background: url("https://lvlin-fe-saas.bj.bcebos.com/material/suoxiao.png") no-repeat center / 100% 100%;
        margin-left: 20px;
    }
}

.avatar-border-bg {
    background: url("https://lvlin-fe-saas.bj.bcebos.com/material/avatar-mask.png") no-repeat top center / 100% 100%;
    position: absolute;
    top: 0;
    height: 468px;
    width: 468px;
    pointer-events: none;
}
</style>
<style lang="less">
.cropper-avator-dialog-new {
    .veui-dialog-content {
        width: 516px !important;
        border-radius: 8px;
    }

    .veui-dialog-content-body {
        overflow: hidden;
        padding: 0 24px !important;
    }

    .veui-dialog-content-foot {
        padding-top: 24px !important;
        display: flex;
        justify-content: space-between;

        .veui-button {
            width: 120px;
            height: 44px;
            border-radius: 6px;
        }

        .veui-button.confirm-btn {
            background: #05f;
            color: #fff;
            border: 1px solid transparent;
        }

        .veui-button.last-step-btn {
            border: 1px solid #1e1f2433;
            background: #fff;
            color: #1e1f24;
        }
    }
}
</style>
